export const AUTH_STORAGE_KEY = 'accessToken';
export const CONFIG_STORAGE_KEY = 'config';
export const TAB_ID = '_tI';
export const TABS_STATUS_LIST = '_tsl';
export const IDLE_STATUS = '_is';
export const LANG = '_l';
